document.addEventListener('DOMContentLoaded', function () {

    FwyReact.initializeTables();

    //Auto Insurance Costs Eased in 2025, But Regional Gaps Persist in 2026
    FwyReact.fwyLineWithHighestAndLowest('js-rate-trend-chart', {
        aspectRatio: 3,
        color: '#CD2900',
        data: [
            { name: "Q1 '24", uv: 169.37 },
            { name: "Q2 '24", uv: 171.01 },
            { name: "Q3 '24", uv: 173.48 },
            { name: "Q4 '24", uv: 170.02 },
            { name: "Q1 '25", uv: 173.90 },
            { name: "Q2 '25", uv: 170.01 },
            { name: "Q3 '25", uv: 165.84 },
            { name: "Q4 '25", uv: 163.80 },
        ],
        yAxisValues: [160, 165, 170, 175, 180]
    })

    //Are Car Insurance Rates Going Up in 2026?
    FwyReact.fwyLineWithHighest('js-monthly-rate-comparison', {
        maxWidth: 1000,
        aspectRatio: 2,
        data: [
            { month: "JAN", "2024": 174.44, "2025": 174.15 },
            { month: "FEB", "2024": 168.07, "2025": 174.80 },
            { month: "MAR", "2024": 166.80, "2025": 172.93 },
            { month: "APR", "2024": 166.80, "2025": 171.23 },
            { month: "MAY", "2024": 171.27, "2025": 169.93 },
            { month: "JUN", "2024": 174.94, "2025": 168.75 },
            { month: "JUL", "2024": 174.03, "2025": 166.62 },
            { month: "AUG", "2024": 172.67, "2025": 167.07 },
            { month: "SEP", "2024": 173.80, "2025": 163.83 },
            { month: "OCT", "2024": 168.68, "2025": 163.75 },
            { month: "NOV", "2024": 169.06, "2025": 164.35 },
            { month: "DEC", "2024": 172.52, "2025": 163.32 },
        ],
        xAxisLabel: "*Based on annualized premiums calculated from actual monthly policy data for Freeway customers (2024–2025).",
    })

    FwyReact.fwyZeroCenterBarChart('js-top-states', {
        data: [
            { state: "DC", change: 18 },
            { state: "VT", change: 14 },
            { state: "NH", change: 11 },
            { state: "WV", change: 10 },
            { state: "NV", change: 10 },
            { state: "MN", change: -8 },
            { state: "AK", change: -8 },
            { state: "SC", change: -10 },
            { state: "MI", change: -12 },
            { state: "FL", change: -13 },
        ]
    })

    //How Did Car Insurance Prices Compare from Q4 2025 to Q4 2024?
    FwyReact.fwyLineWithHighest('js-exampleId2', {
        maxWidth: 1000,
        aspectRatio: 2.4,
        disableStaticTooltip: true,
        line1Name: "Monthly Premiums 2024",
        line2Name: "Monthly Premiums 2025",
        yAxisValues: [462, 470, 480, 490, 500, 510, 520, 530],
        yAxisMobileValues: [462, 470, 480, 490, 500, 510, 520, 530],
        data: [
            { name: "Q1", "2024": 508.10, "2025": 521.71 },
            { name: "Q2", "2024": 513.02, "2025": 510.02 },
            { name: "Q3", "2024": 520.44, "2025": 497.51 },
            { name: "Q4", "2024": 510.06, "2025": 491.39 },
        ]
    })


    //Full Coverage Trends
    FwyReact.fwyLineWithHighest('js-exampleId3', {
        maxWidth: 1000,
        aspectRatio: 2,
        yAxisValues: [170, 175, 180, 185, 190, 195, 200, 205, 210, 215],
        yAxisMobileValues: [170, 175, 180, 185, 190, 195, 200, 205, 210, 215],
        data: [
            { month: "JAN", "2024": 199.06, "2025": 206.38 },
            { month: "FEB", "2024": 195.42, "2025": 212.74 },
            { month: "MAR", "2024": 194.42, "2025": 206.30 },
            { month: "APR", "2024": 194.65, "2025": 205.25 },
            { month: "MAY", "2024": 197.95, "2025": 201.46 },
            { month: "JUN", "2024": 201.82, "2025": 199.82 },
            { month: "JUL", "2024": 199.68, "2025": 199.14 },
            { month: "AUG", "2024": 202.42, "2025": 197.23 },
            { month: "SEP", "2024": 203.93, "2025": 194.43 },
            { month: "OCT", "2024": 202.81, "2025": 195.09 },
            { month: "NOV", "2024": 202.19, "2025": 193.55 },
            { month: "DEC", "2024": 203.11, "2025": 190.63 },
        ],
    })

    //Liability-Only Trends
    FwyReact.fwyLineWithHighest('js-exampleId4', {
        maxWidth: 1100,
        aspectRatio: 2.4,
        yAxisValues: [92, 100, 110, 120, 130, 140, 150],
        yAxisMobileValues: [92, 100, 110, 120, 130, 140, 150],
        data: [
            { month: "JAN", "2024": 132.93, "2025": 125.39 },
            { month: "FEB", "2024": 132.38, "2025": 128.94 },
            { month: "MAR", "2024": 133.02, "2025": 126.71 },
            { month: "APR", "2024": 128.30, "2025": 126.96 },
            { month: "MAY", "2024": 130.05, "2025": 125.70 },
            { month: "JUN", "2024": 135.46, "2025": 125.37 },
            { month: "JUL", "2024": 133.33, "2025": 123.60 },
            { month: "AUG", "2024": 124.77, "2025": 122.17 },
            { month: "SEP", "2024": 118.61, "2025": 120.06 },
            { month: "OCT", "2024": 118.78, "2025": 121.84 },
            { month: "NOV", "2024": 118.31, "2025": 122.31 },
            { month: "DEC", "2024": 142.11, "2025": 120.28 },
        ],
    })
});